// <--server-->

// load locales
export const loadLocales = (fs, path, locales) => {
  const resources = {};
  locales.forEach((lng) => {
    const filePath = path.resolve("public/locales", `${lng}.json`);
    const data = fs.readFileSync(filePath, "utf8");
    resources[lng] = { translation: JSON.parse(data) };
  });
  return resources;
};

// <--client-->

// helpers/downloadFile.js
import apiClient from "../lib/apiClient";
import { error } from "../components/ui/toast";

export async function getDownload(name) {
  try {
    const response = await apiClient.get(`/getDownload/${name}`, {
      responseType: 'blob',
    });

    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
    const link = document.createElement('a');
    const isPDF = name.toLowerCase().endsWith('.pdf');
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    // For PDF files
    if (isPDF) {
      // Safari requires
      if (isSafari) {
        link.href = url;
        link.setAttribute('download', name);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }

      // Other browsers
      window.open(url, '_blank');
    } else {
      // For non-PDF files
      link.href = URL.createObjectURL(new Blob([response.data]));
      link.setAttribute('download', name);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    return response.data;
  } catch (err) {
    error(err);
  }
}

// Current year
export function getCurrentYear() {
  return new Date().getFullYear();
}

//
import { localesRegex } from "./regex";
export const navigateWithLocal = (pathname) =>
  pathname.replace(localesRegex, "")

// scrollers
export const smoothScroll = () => {
  return window.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth",
  });
}

export const customScroll = () => {
  return window.scrollTo(0, 0)
};